"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _styles = require("@mui/styles");

var _StepperFooterContainer = require("./StepperFooterContainer");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    footer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 -1px 2px 0 ".concat(palette.grey.main),
      transition: 'width .2s ease-out',
      padding: spacing(2),
      backgroundColor: palette.common.white
    },
    backButton: {
      color: palette.link.main,
      border: "1px solid ".concat(palette.divider),
      backgroundColor: palette.common.white,
      boxShadow: 'none'
    },
    nextButton: {
      boxShadow: 'none'
    },
    loading: {
      height: '20px!important',
      width: '20px!important'
    },
    hiddenButton: {
      display: 'none'
    }
  };
});

var StepperFooter = function StepperFooter(_ref2) {
  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      _ref2$onClickBack = _ref2.onClickBack,
      onClickBack = _ref2$onClickBack === void 0 ? undefined : _ref2$onClickBack,
      onClickNext = _ref2.onClickNext,
      _ref2$nextButtonText = _ref2.nextButtonText,
      nextButtonText = _ref2$nextButtonText === void 0 ? 'Next' : _ref2$nextButtonText,
      _ref2$nextButton = _ref2.nextButton,
      nextButton = _ref2$nextButton === void 0 ? null : _ref2$nextButton;
  var classes = useStyles();
  var nextButtonIcon = isLoading ? /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    size: 20
  }) : /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "arrow-right"
  });

  var _useState = (0, _react.useState)(document.getElementById(_StepperFooterContainer.STEPPER_CONTAINER_ID)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      portalNode = _useState2[0],
      setPortalNode = _useState2[1];

  var submitButtonRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var timer;

    if (!portalNode) {
      timer = setInterval(function () {
        setPortalNode(document.getElementById(_StepperFooterContainer.STEPPER_CONTAINER_ID));
      }, 100);
    }

    return function () {
      clearInterval(timer);
    };
  }, [portalNode]);

  var handleClickNext = function handleClickNext() {
    if (onClickNext) {
      onClickNext();
    } else {
      var _submitButtonRef$curr;

      (_submitButtonRef$curr = submitButtonRef.current) === null || _submitButtonRef$curr === void 0 ? void 0 : _submitButtonRef$curr.click();
    }
  };

  var footer = /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.footer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: onClickBack ? 'space-between' : 'flex-end',
    width: 1
  }, !!onClickBack && /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: onClickBack,
    color: "default",
    variant: "contained",
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "arrow-left"
    }),
    className: classes.backButton
  }, "Back"), nextButton || /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: handleClickNext,
    type: "button",
    disabled: disabled,
    color: "primary",
    variant: "contained",
    endIcon: nextButtonIcon,
    className: classes.nextButton
  }, nextButtonText)));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    ref: submitButtonRef,
    className: classes.hiddenButton,
    type: "submit"
  }, "submit"), !portalNode && footer, portalNode && /*#__PURE__*/(0, _reactDom.createPortal)(footer, portalNode));
};

var _default = StepperFooter;
exports.default = _default;